import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import CustomInstructionsHeader from "./CustomInstructionsHeader";
import CustomInstructionsSidebar from "./CustomInstructionsSidebar";
import { CarouselChatTab } from "./tabs";
const TABS = [
    { id: "powerpoint", label: "PowerPoint" },
    { id: "excel", label: "Excel" },
];
const CustomInstructionsApp = ({ initialTab = 0, initialMode, }) => {
    const defaultTab = initialMode || TABS[initialTab]?.id || "powerpoint";
    const [selectedTab, setSelectedTab] = useState(defaultTab);
    const handleTabChange = (tabId) => {
        if (tabId === "powerpoint" || tabId === "excel") {
            setSelectedTab(tabId);
        }
    };
    return (_jsxs("div", { className: "flex flex-col h-screen w-full bg-gray-100 font-sans", children: [_jsx(CustomInstructionsHeader, {}), _jsxs("div", { className: "flex flex-1 overflow-hidden", children: [_jsx(CustomInstructionsSidebar, { tabs: TABS, activeTab: selectedTab, onTabChange: handleTabChange }), _jsx("div", { className: "flex-1 overflow-y-auto pt-3 px-6 pb-6 bg-white", children: _jsx("div", { className: "max-w-[700px]", children: _jsx(CarouselChatTab, { mode: selectedTab }) }) })] })] }));
};
export default CustomInstructionsApp;
